const mediaCarousels = document.querySelectorAll('.media-carousel.swiper-slider');

mediaCarousels.forEach((mediaCarousel) => {
    const swiper = new Swiper(mediaCarousel, {
        effect: 'coverflow',
        loop: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
            rotate: 0,
            stretch: 30,
            depth: 100,
            scale: 0.5,
            modifier: 1,
            slideShadows: true,
        },
        autoplay: false,
        navigation: {
            prevEl: mediaCarousel.querySelector('.swiper-button-prev'),
            nextEl: mediaCarousel.querySelector('.swiper-button-next'),
        },
    });

    mediaCarousel.querySelectorAll('.media-wrapper').forEach((wrapper) => {
        const video = wrapper.querySelector('.media-video');
        const btn = wrapper.querySelector('.video-play-pause');
        const track = wrapper.querySelector('.video-progress-track');
        const bar = wrapper.querySelector('.video-progress-bar');

        if (!video || !btn) return;

        btn.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                btn.classList.add('is-playing');
            } else {
                video.pause();
                btn.classList.remove('is-playing');
            }
        });

        video.addEventListener('timeupdate', () => {
            if (video.duration) {
                bar.style.width = (video.currentTime / video.duration * 100) + '%';
            }
        });

        track.addEventListener('click', (e) => {
            const rect = track.getBoundingClientRect();
            video.currentTime = ((e.clientX - rect.left) / rect.width) * video.duration;
        });

        video.addEventListener('ended', () => {
            btn.classList.remove('is-playing');
            bar.style.width = '0%';
        });
    });
});
